import Vue from 'vue';
import Vuex from 'vuex';
import auth from "./modules/auth";
import mission from "@/store/modules/mission";
import page from '@/store/modules/page';

Vue.use(Vuex);

export default new Vuex.Store(
  {
    modules: {
      auth: auth,
      mission: mission,
      page: page
    },
  });
